import { render, staticRenderFns } from "./TransactionStoreTable.vue?vue&type=template&id=0cca98f0&scoped=true"
import script from "./TransactionStoreTable.vue?vue&type=script&lang=js"
export * from "./TransactionStoreTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionStoreTable.vue?vue&type=style&index=0&id=0cca98f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca98f0",
  null
  
)

export default component.exports